/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import defaultRequest from ".";

export class CrudApi {
    request = defaultRequest;

    constructor(entity) {
        this.entity = entity;
        this.url = `/api/v1/${entity}/`;
    }

    get(config) {
        return this.request.get(this.url, config).then(({ data }) => data);
    }

    patch(id, ...args) {
        return this.request
            .patch(`${this.url}${id}`, ...args)
            .then(({ data }) => data);
    }

    createOne(data, config) {
        return this.request
            .post(this.url, data, config)
            .then(({ data }) => data);
    }

    createBatch() {}

    getById = (id, config) =>
        this.request.get(`${this.url}${id}`, config).then(({ data }) => data);

    updateOne(data, params) {
        return this.request.patch(data, params).then(({ data }) => {
            const [entity] = data[this.entity];
            return { ...data, [this.entity]: entity };
        });
    }

    updateBatch() {}

    deleteOne() {}

    deleteBatch() {}

    init(requestMethod, data, config) {
        return {
            data,
            config,
            include(value) {
                if (typeof this.config === "undefined") {
                    this.config = { params: { include: [value] } };
                } else if (typeof this.config.params === "undefined") {
                    this.config.params = { include: [value] };
                } else if (!Array.isArray(this.config.params.include)) {
                    this.config.params.include = [value];
                } else {
                    this.config.params.include.push(value);
                }
                return this;
            },
            filter(entity, value) {
                if (typeof this.config === "undefined") {
                    this.config = { params: { [`filter{${entity}}`]: value } };
                } else if (typeof this.config.params === "undefined") {
                    this.config.params = { [`filter{${entity}}`]: value };
                } else {
                    this.config.params[`filter{${entity}}`] = value;
                }
                return this;
            },
            fetch() {
                return requestMethod(this.data, this.config);
            },
        };
    }
}
